var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-container"},[_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell small-12 medium-6 medium-offset-3"},[_c('div',{staticClass:"upload-zone DashboardContainer"})])])])
}]

export { render, staticRenderFns }